import { cva } from 'class-variance-authority';

// CVA Styles
export const cvaCardContainer = cva([
  'payments-dialog-styles-cvaCardContainer',
  'bg-general_background_MIII_450_dark',
  'rounded-2xl',
  'shadow-[0px_4px_40px_0px_rgba(0,0,0,0.24)]',
  'p-8',
  'relative',
  'max-w-3xl',
]);

export const cvaCurrentPlanLabel = cva([
  'payments-dialog-styles-cvaCurrentPlanLabel',
  'text-[#a1a2a8]',
  'mb-1',
]);

export const cvaPlanTitle = cva([
  'ff-inter',
  'payments-dialog-styles-cvaPlanTitle',
  'text-font_ds_title_title_title_32',
  'text-general_text_MII_default',
]);

export const cvaHeaderContainer = cva([
  'payments-dialog-styles-cvaHeaderContainer',
  'flex items-center justify-between',
  'gap-4',
  'mb-6',
]);

export const cvaUpgradeButton = cva([
  'ff-inter',
  'payments-dialog-styles-cvaUpgradeButton',
  'px-8',
  'self-end',
]);

export const cvaContentContainer = cva([
  'payments-dialog-styles-cvaContentContainer',
  'bg-general_background_MIII_500_dark',
  'rounded-lg',
  'flex items-center',
]);

export const cvaImageContainer = cva([
  'payments-dialog-styles-cvaImageContainer',
  'relative',
  'shrink-0 ',
  'w-[11.75rem] h-[11.75rem]',
  'flex items-center justify-center',
]);

export const cvaBackgroundImage = cva([
  'payments-dialog-styles-cvaBackgroundImage',
  'absolute',
  'min-w-[17rem]',
  'min-h-[15.75rem]',
  'rotate-[8deg]',
]);

export const cvaCharacterImage = cva([
  'payments-dialog-styles-cvaCharacterImage',
  'relative',
  'w-full',
  'h-full',
  'object-cover',
  'rotate-[12deg]',
]);

export const cvaTextContainer = cva(['payments-dialog-styles-cvaTextContainer', 'flex-1', 'p-6']);

export const cvaContentTitle = cva([
  'ff-inter',
  'payments-dialog-styles-cvaContentTitle',
  'text-general_text_MII_default',
  'text-font_ds_title_body_black_20',
  'mb-2',
]);

export const cvaContentDescription = cva([
  'ff-inter',
  'payments-dialog-styles-cvaContentDescription',
  'text-general_text_MII_secondary_ii',
  'text-font_ds_title_body_body_14',
  'mb-4',
]);

export const cvaFeaturesGrid = cva([
  'ff-inter',
  'payments-dialog-styles-cvaFeaturesGrid',
  'grid',
  'grid-cols-2',
  'gap-4',
]);

export const cvaFeatureItem = cva([
  'payments-dialog-styles-cvaFeatureItem',
  'flex',
  'gap-2',
  'items-start',
]);

export const cvaFeatureIcon = cva([
  'payments-dialog-styles-cvaFeatureIcon',
  'text-general_MI_700_pressed',
  'shrink-0',
]);

export const cvaFeatureText = cva([
  'payments-dialog-styles-cvaFeatureText',
  'text-general_ico_MIV_500_default',
]);
